// src/utils/DataMethods.ts
function isNull(arg) {
  return arg === null;
}
function isNotNull(arg) {
  return arg !== null;
}
function isUndefined(arg) {
  return typeof arg === "undefined";
}
function isNullOrUndefined(arg) {
  return isNull(arg) || isUndefined(arg);
}
function isNotUndefined(arg) {
  return typeof arg !== "undefined";
}
function isNotNullOrUndefined(arg) {
  return isNotNull(arg) && isNotUndefined(arg);
}
function isObject(arg) {
  return typeof arg === "object" && arg !== null && !Array.isArray(arg) && !isString(arg);
}
function isEmptyObject(arg) {
  return isNotNullOrUndefined(arg) && isObject(arg) && Object.keys(arg).length === 0;
}
function isNotEmptyObject(arg) {
  return isNotNullOrUndefined(arg) && isObject(arg) && !isEmptyObject(arg);
}
function isArray(arg) {
  return Array.isArray(arg);
}
function isEmptyArray(arg) {
  return isArray(arg) && arg.length === 0;
}
function isNotEmptyArray(arg) {
  return isArray(arg) && !isEmptyArray(arg);
}
function isLastArrayItem(array, item) {
  return array.indexOf(item) === array.length - 1;
}
function isFirstArrayItem(array, item) {
  return array.indexOf(item) === 0;
}
function isNullOrEmptyObject(arg) {
  return isUndefined(arg) || isNull(arg) || isEmptyObject(arg);
}
function isNotNullOrEmptyObject(arg) {
  return !isNullOrEmptyObject(arg);
}
function isEmptyData(arg) {
  return isNullOrUndefined(arg) || isNullOrEmptyObject(arg) || isEmptyArray(arg) || isEmptyString(arg);
}
function isNotEmptyData(arg) {
  return !isEmptyData(arg);
}
function isEmptyValue(arg) {
  const checkContent = (collection) => collection.every(
    (value) => isNullOrEmptyObject(value) || isEmptyArray(value) || isEmptyString(value)
  );
  return isNullOrUndefined(arg) || arg === "" || arg === 0 || isEmptyArray(arg) || isNotEmptyArray(arg) && checkContent(arg) || isEmptyObject(arg) || isNotEmptyObject(arg) && checkContent(Object.values(arg));
}
function isNotEmptyValue(arg) {
  return !isEmptyValue(arg);
}
function isString(arg) {
  return typeof arg === "string";
}
function isEmptyString(arg) {
  return isString(arg) && arg.trim() === "";
}
function isNotEmptyString(arg) {
  return isEmptyString(arg) === false;
}
function isNumber(arg) {
  return typeof arg === "number";
}
function isBoolean(arg) {
  return typeof arg === "boolean";
}
function isFunction(arg) {
  return typeof arg === "function";
}
function openInNewTab(url) {
  window.open(url, "_blank", "noopener noreferrer");
}
function prepareDownloadLink(url, fileName) {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  link.id = `download-link-${fileName}`;
  if (isUndefined(link.download)) {
    link.setAttribute("target", "_blank");
  }
  document.body.appendChild(link);
  return link;
}
function downloadFile(url, fileName) {
  const tempLink = prepareDownloadLink(url, fileName);
  tempLink.click();
  setTimeout(() => {
    document.body.removeChild(tempLink);
  }, 200);
}
function convertToEnum(enumObj, enumKey) {
  return enumObj[enumKey];
}
function convertFromEnum(enumObj, enumValue) {
  return enumObj[enumValue];
}
function accessNestedProperty(object, path, defaultValue) {
  try {
    if (typeof path === "string") {
      path = path.split(".").map((key) => {
        const numKey = Number(key);
        return Number.isNaN(numKey) ? key : numKey;
      });
    }
    let result = object;
    for (const key of path) {
      if (result === void 0 || result === null) return defaultValue;
      result = result[key];
    }
    return result !== void 0 ? result : defaultValue;
  } catch {
    return defaultValue;
  }
}
function omit(object, keysToOmit) {
  const result = { ...object };
  for (const key of keysToOmit) delete result[key];
  return result;
}
function getObjectKeys(obj) {
  const keys = Object.keys(obj);
  return keys.map((key) => key);
}
function generateUUId(input) {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return "xxxxxxxx".replace(/x/g, () => {
    const r = (hash + Math.random() * 16) % 16 | 0;
    hash = Math.floor(hash / Math.random() * 16);
    return r.toString(16);
  });
}

export {
  isNull,
  isNotNull,
  isUndefined,
  isNullOrUndefined,
  isNotUndefined,
  isNotNullOrUndefined,
  isObject,
  isEmptyObject,
  isNotEmptyObject,
  isArray,
  isEmptyArray,
  isNotEmptyArray,
  isLastArrayItem,
  isFirstArrayItem,
  isNullOrEmptyObject,
  isNotNullOrEmptyObject,
  isEmptyData,
  isNotEmptyData,
  isEmptyValue,
  isNotEmptyValue,
  isString,
  isEmptyString,
  isNotEmptyString,
  isNumber,
  isBoolean,
  isFunction,
  openInNewTab,
  prepareDownloadLink,
  downloadFile,
  convertToEnum,
  convertFromEnum,
  accessNestedProperty,
  omit,
  getObjectKeys,
  generateUUId
};
//# sourceMappingURL=chunk-NQ7GJGRO.js.map